"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCircleButtonSubtitle = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var colorSwitch = function (color) {
    switch (color) {
        case "light":
            return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", "\n      "], ["\n        ", "\n      "])), style_utils_1.getColor("gray", 500));
        case "link":
            return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        ", ";\n      "], ["\n        ", ";\n      "])), style_utils_1.getColor("primary", 500));
        default:
            return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        ", ";\n      "], ["\n        ", ";\n      "])), function (props) { return style_utils_1.colorSelector(props, props.color, 500); });
    }
};
exports.StyledCircleButtonSubtitle = styled_components_1.default.small(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-transform: uppercase;\n  font-size: 9px;\n  color: ", ";\n"], ["\n  text-transform: uppercase;\n  font-size: 9px;\n  color: ",
    ";\n"])), function (props) {
    return props.disabled || props.isLoading
        ? style_utils_1.colorSelector(props, "gray", 400)
        : colorSwitch(props.color);
});
var CircleButtonSubtitle = function (_a) {
    var children = _a.children, size = _a.size, props = __rest(_a, ["children", "size"]);
    if (size !== "sm" && size !== "xs" && children) {
        return (react_1.default.createElement(exports.StyledCircleButtonSubtitle, __assign({}, props, { size: size }), children));
    }
    return null;
};
exports.default = CircleButtonSubtitle;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map